import type { SlackConnection } from "@/types/api";
import { http } from "./http";

export const slackService = {
	getConnection: (signal?: AbortSignal) =>
		http.get<SlackConnection>("/api/org/integrations/slack", { signal }),
	startConnection: () =>
		http.post<{ url: string }>("/api/org/integrations/slack/connect"),
	disconnect: () => http.del<void>("/api/org/integrations/slack"),
};
